import styled from "styled-components";

const FADE = "240ms ease";

export const StyledStepNameLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #3c4257;
  transition: color ${FADE};

  &.current {
    color: #1249bf;
  }

  &.completed {
    color: var(--CLOUD, #fcfdfe);
  }
`;

export const StyledStepDescriptionLabel = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #697386;
  transition: color ${FADE};

  &.current {
    color: #0e0e2c;
  }

  &.completed {
    color: var(--CLOUD, #fcfdfe);
  }
`;

export const StyledFormLabel = styled.label`
  color: var(--GREY, #4a4a68);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 4px;

  &.req {
    &::after {
      content: " *";
      color: var(--DANGER, #cf324a);
    }
  }
`;

export const StyledFormWithRightContentLabel = styled.label`
  color: var(--GREY, #4a4a68);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;

  &.req,
  .req {
    &::after {
      content: " *";
      color: var(--DANGER, #cf324a);
    }
  }
`;

export const StyledFormWithRightContentLabelAsDiv = styled.div`
  color: var(--GREY, #4a4a68);
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;

  &.req,
  .req {
    &::after {
      content: " *";
      color: var(--DANGER, #cf324a);
    }
  }
`;

export const StyledFormLabelWithIcon = styled.label`
  color: var(--GREY, #4a4a68);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    &.req {
      &::after {
        content: " *";
        color: var(--DANGER, #cf324a);
      }
    }
  }
  &.ft14 {
    font-size: 14px;
    color: var(--ASH, #676879);
    margin-bottom: 0;
  }
`;

export const StyledProgessLabel = styled.label`
  color: #262641;
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 4px;

  &.elipsis {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
